<div class="inspector">
  @if (!item || item === 'Default') {
    <div class="empty-state">
      <fa-icon [icon]="faHandPointer" class="empty-state-icon"></fa-icon>
      <span class="empty-state-title">Nothing selected</span>
      <span class="empty-state-description">Select an element to view its available tools and details here.</span>
    </div>
  }
  <div class="scrollable-container">
    <ng-container #inspectorContainer></ng-container>
  </div>
</div>

